import { alpha, Theme } from '@mui/material';

// Single source of truth for the portal's glass idiom — never hand-copy this value.
export const GLASS_BLUR = 'blur(14px) saturate(1.4)';

const SUPPORTS_BACKDROP_FILTER =
  '@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px)))';

/**
 * Deep token-tinted glass for the composer banners: `token` becomes the ink, mixed into a
 * surface base and thinned to a fixed opacity. Base/tint/opacity come from the per-mode
 * `OV.custom.Glass` tokens, so this never branches on the theme mode itself.
 */
export function getGlassTintStyles(theme: Theme, token: string) {
  const { surfaceContainerLow } = theme.palette.custom.OV.sys;
  const { base, tintPercent, opacityPercent } = theme.palette.custom.OV.custom.Glass;

  return {
    background: `color-mix(in srgb, color-mix(in srgb, ${token} ${tintPercent}%, ${base}) ${opacityPercent}%, transparent)`,
    backdropFilter: GLASS_BLUR,
    WebkitBackdropFilter: GLASS_BLUR,
    border: `1px solid ${alpha(token, 0.28)}`,
    supportsFallback: {
      // no blur capability: fall back to an opaque tint mix, never bare translucency
      background: `color-mix(in srgb, ${token} 22%, ${surfaceContainerLow})`,
    },
  };
}

export { SUPPORTS_BACKDROP_FILTER };
